// Mega menu — logika przewijania w bok.
// Przyciski .gg-mega-arrow są renderowane server-side w _header-menu.liquid.
// Ten skrypt podpina klik + pokazuje/chowa strzałki wg pozycji scrolla.

(function () {
  const SCROLL_STEP = 0.85;

  function wire(mega) {
    if (mega.dataset.ggArrowsWired === '1') return;
    const list = mega.querySelector('.mega-menu__list');
    const prev = mega.querySelector('.gg-mega-arrow--prev');
    const next = mega.querySelector('.gg-mega-arrow--next');
    if (!list || !prev || !next) return;
    mega.dataset.ggArrowsWired = '1';

    // Threshold 30px (nie 4) — accomoduje padding-inline + sub-pixel imprecision
    // smooth scrolla po powrocie do pozycji 0. Bez tego prev zostawała widoczna
    // gdy scrollLeft kończył np. na 6-10px.
    const EDGE = 30;
    function recompute() {
      const max = list.scrollWidth - list.clientWidth - 1;
      if (max <= EDGE) {
        prev.classList.remove('is-active');
        next.classList.remove('is-active');
        return;
      }
      prev.classList.toggle('is-active', list.scrollLeft > EDGE);
      next.classList.toggle('is-active', list.scrollLeft < max - EDGE);
    }

    // preventDefault na pointerdown/mousedown — button nie kradnie focusu,
    // przez co aria-expanded na menu-linku zostaje, menu się nie zamyka.
    // stopPropagation — żeby click nie bąblował do theme handlerów.
    const guard = (e) => { e.preventDefault(); e.stopPropagation(); };
    [prev, next].forEach((b) => {
      b.addEventListener('pointerdown', guard);
      b.addEventListener('mousedown', guard);
    });
    prev.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      list.scrollBy({ left: -list.clientWidth * SCROLL_STEP, behavior: 'smooth' });
    });
    next.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      list.scrollBy({ left: list.clientWidth * SCROLL_STEP, behavior: 'smooth' });
    });

    list.addEventListener('scroll', recompute, { passive: true });
    window.addEventListener('resize', recompute, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(recompute).observe(list);
    }

    recompute();
  }

  function wireAll() {
    document.querySelectorAll('.menu-list__submenu .mega-menu').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  window.addEventListener('load', wireAll);
})();
